// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReactTable {\n    height: 300px;\n}\n\n.detailReportInfo {\ndisplay: none;\npadding-left: 0.5rem;\npadding-top: 1.5rem;\nfont-size: smaller;\n}\n      \n.detailReportDiv:hover + .detailReportInfo {\ndisplay: block;\ncolor: red;\n}\n\n.detailReportDiv {\n    padding: 0.5rem;\n    padding-top: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
